import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import axios from 'axios';
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      map: null,
      marker: null,
      formData: {
        id: "",
        location: "",
        location_img: "",
        location_name: "",
        lat: "",
        // 纬度
        lng: "" // 经度

      },
      imgList: [],
      rules: {
        location: [{
          required: true,
          message: "请选择或输入地址",
          trigger: "change"
        }],
        location_img: [{
          required: true,
          message: "请上传场地logo",
          trigger: "blur"
        }],
        location_name: [{
          required: true,
          message: "请输入场地名称",
          trigger: "blur"
        }]
      },
      AMAP_JS_KEY: "7be3ab61691229ab0d90c86b6b6a9b9f",
      // 替换为自己的高德Key
      AMAP_WEB_KEY: 'a6e34878459007a4e2ff6a8650333a7c'
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.copyPrimitive();

                  datas = JSON.parse(JSON.stringify(data));
                  _this.formData = _objectSpread({}, datas);
                  _this.imgList = [datas.location_img];

                  _this.copyData();
                }

                _this.dialogFormVisible = true; // 弹窗打开后初始化地图

                _this.$nextTick(function () {
                  _this.initAmap();
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 1. 初始化高德地图（替换腾讯地图）
    initAmap: function initAmap() {
      var _this2 = this;

      window._AMapSecurityConfig = {
        securityJsCode: 'b7e5be5f4235922f5f38501bae445abb' // <--- 替换成你刚查到的密钥

      }; // 动态加载高德地图SDK

      if (!window.AMap) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://webapi.amap.com/maps?v=2.0&key=".concat(this.AMAP_JS_KEY, "&callback=onAmapCallback");
        document.head.appendChild(script);

        window.onAmapCallback = function () {
          _this2.createAmap();
        };
      } else {
        this.createAmap();
      }
    },
    // 创建高德地图实例
    createAmap: function createAmap() {
      var _this3 = this;

      // 默认中心点（北京）
      var defaultCenter = [116.397128, 39.916527]; // 高德：[经度, 纬度]
      // 创建地图

      this.map = new window.AMap.Map(document.getElementById("map-container"), {
        center: defaultCenter,
        zoom: 13,
        resizeEnable: true // 自适应容器尺寸

      }); // 创建标记

      this.marker = new window.AMap.Marker({
        map: this.map,
        position: defaultCenter
      });
      window.AMap.plugin(['AMap.Geocoder'], function () {
        var geocoder = new window.AMap.Geocoder({
          city: '全国',
          extensions: 'all' // 设置为 all，可以获取点击位置周边的 POI 关键信息

        });

        _this3.map.on('click', function (e) {
          var _e$lnglat = e.lnglat,
              lng = _e$lnglat.lng,
              lat = _e$lnglat.lat;
          var position = [lng, lat];

          _this3.marker.setPosition(position);

          _this3.formData.lng = lng;
          _this3.formData.lat = lat;
          geocoder.getAddress(position, function (status, result) {
            if (status === 'complete' && result.regeocode) {
              // 1. 详细地址
              var address = result.regeocode.formattedAddress; // 2. 尝试获取附近最贴切的建筑名称（AOI/POI）

              var name = "";
              var regeocode = result.regeocode;

              if (regeocode.aois && regeocode.aois.length > 0) {
                name = regeocode.aois[0].name; // 区域名，如：XX小区、XX大厦
              } else if (regeocode.pois && regeocode.pois.length > 0) {
                name = regeocode.pois[0].name; // 兴趣点名
              } else {
                name = regeocode.addressComponent.streetNumber || regeocode.addressComponent.street;
              }

              _this3.formData.location = address;
              _this3.formData.location_name = name;
            }
          });
        });
      });

      if (this.formData.lng && this.formData.lat) {
        var currentCenter = [this.formData.lng, this.formData.lat];
        this.map.setCenter(currentCenter);
        this.marker.setPosition(currentCenter);
      } // 如果没有已有坐标，尝试获取用户定位
      // if (navigator.geolocation && !this.formData.id) {
      //   this.getUserLocation();
      // }
      // 尝试获取用户定位

    },
    getUserLocation: function getUserLocation() {
      var _this4 = this;

      if (!navigator.geolocation) {
        console.warn("浏览器不支持定位");
        return;
      }

      navigator.geolocation.getCurrentPosition(function (position) {
        var lng = position.coords.longitude;
        var lat = position.coords.latitude;
        var currentCenter = [lng, lat]; // 移动地图到当前位置

        _this4.map.setCenter(currentCenter);

        _this4.marker.setPosition(currentCenter);

        _this4.map.setZoom(15); // 更新坐标


        _this4.formData.lng = lng;
        _this4.formData.lat = lat; // 获取当前位置的地址

        _this4.reverseGeocodeByWebAPI(lng, lat);
      }, function (error) {
        console.warn("定位失败：", error.code, error.message); // 不显示错误提示，让用户手动选择
      }, {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      });
    },
    // 2. 高德地图地址搜索（防抖+避免重复调用）
    querySearchAsync: function querySearchAsync(queryString, cb) {
      var _this5 = this;

      if (!queryString || queryString.trim().length < 2) {
        return cb([]);
      } // 防抖：避免频繁调用API


      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, list;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return axios.get('https://restapi.amap.com/v3/place/text', {
                  params: {
                    keywords: queryString.trim(),
                    key: _this5.AMAP_WEB_KEY,
                    output: 'json',
                    city: '全国',
                    page_size: 10
                  }
                });

              case 3:
                res = _context2.sent;

                if (res.data.status === '1') {
                  list = res.data.pois.map(function (item) {
                    return {
                      value: item.name,
                      name: item.name,
                      address: item.address,
                      location: {
                        lng: item.location.split(',')[0],
                        // 高德返回：经度,纬度
                        lat: item.location.split(',')[1]
                      }
                    };
                  });
                  cb(list);
                } else {
                  console.warn("地址搜索失败：", res.data.info);
                  cb([]);
                }

                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                console.error("地址搜索请求失败：", _context2.t0);
                cb([]);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      })), 300);
    },
    // 3. 选中搜索结果（联动地图）
    handleSelect: function handleSelect(item) {
      this.formData.location_name = item.name;
      this.formData.location = item.address;
      this.formData.lng = item.location.lng;
      this.formData.lat = item.location.lat; // 高德地图：[经度, 纬度]

      var position = [item.location.lng, item.location.lat];
      this.map.panTo(position);
      this.marker.setPosition(position);
      this.map.setZoom(16);
    },
    imgChange: function imgChange(e) {
      this.imgList = e;
      this.formData.location_img = e[0] && e[0].response ? e[0].response.url : '';
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.imgList = isClear ? [] : this.formDataMake.location_img ? [this.formDataMake.location_img] : [];
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this6.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var reqFn = _this6.formData.id ? 'updateVenues' : 'addVenues';
                    var data = JSON.parse(JSON.stringify(_this6.formData));

                    _this6.$api[reqFn](data).then(function (res) {
                      if (res.code == 200) {
                        _this6.$message.success(_this6.formData.id ? '修改成功' : '添加成功');

                        _this6.$emit('change');

                        _this6.dialogFormVisible = false;
                      } else {
                        _this6.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  // 弹窗关闭时清理资源，避免内存泄漏
  watch: {
    dialogFormVisible: function dialogFormVisible(val) {
      if (!val) {
        if (this.map) {
          this.map.destroy();
          this.map = null;
          this.marker = null;
        }

        clearTimeout(this.searchTimer);
      }
    }
  }
};